import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";

@Injectable({ providedIn: "root" })
export abstract class AuthGuard {
  #securityService = inject(ZzzSecuriteService);
  #router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.#securityService.utilisateurEstAuthentifie) {
      const requiredRole = route.data.requiredRole as string | undefined;
      if (requiredRole) {
        if (this.#securityService.hasRole(requiredRole)) {
          return true;
        }

        this.#router.navigate(['/accueil']);
        return false;
      }

      const lackRole = route.data.doesntHaveRole as { role: string } | undefined;
      if (lackRole) {
        if (this.#securityService.doesNotHaveRole(lackRole.role)) {
          return true;
        } 
        this.#router.navigate(['/accueil']);
        return false;
      }
      //User must be authenticated. No other specific role required/lacking for this path
      return true;
    }

    this.#router.navigate(['/accueil']);
    return false;
  }
}
